import clsx from 'clsx';
import { type JSX, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { ThemeSettings } from '../../../../constants';

interface Props {
  show: boolean;
  children: JSX.Element | JSX.Element[];
  hideCallback: () => void;
  isCentered?: boolean;
  isStatic?: boolean;
  withoutClose?: boolean;
  className?: string;
  parentClassName?: string;
  preventBluringClose?: boolean;
  preventEscClose?: boolean;
}
const GenericModal = ({
  show,
  children,
  hideCallback,
  isCentered,
  isStatic,
  withoutClose,
  className,
  parentClassName,
  preventEscClose = false,
}: Props) => {
  const { icons: icon } = ThemeSettings!;

  useEffect(() => {
    if (!preventEscClose) return;
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        return false;
      }
    };

    if (show) {
      document.addEventListener('keydown', handleKeyDown, { capture: true });
    }

    return () => {
      if (show) {
        document.removeEventListener('keydown', handleKeyDown, {
          capture: true,
        });
      }
    };
  }, [show, preventEscClose]);

  return (
    <Modal
      show={show}
      onHide={() => {
        hideCallback();
      }}
      backdrop={isStatic && 'static'}
      centered={isCentered}
      dialogClassName={
        parentClassName ? parentClassName : 'generic-modal-width'
      }
      onExit={() => {
        document.body.setAttribute('style', '');
      }}
    >
      {!withoutClose && (
        <i
          className={clsx(icon?.close, 'custom-modal__close')}
          onClick={hideCallback}
        />
      )}
      <Modal.Body className={clsx('custom-modal mt-2', className)}>
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default GenericModal;
